import { animate, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AssetDto } from '@nusign/picflow-backend-types';
import { BlurHashPipe } from '../../../pipes/blur-hash.pipe';

@Component({
  selector: 'app-asset-page-blur-hash',
  imports: [BlurHashPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('blurHash', [
      state('previous', style({ opacity: 0 })),
      state('current', style({ opacity: 0.35 })),
      transition('previous <=> current', [animate('2s ease')]),
    ]),
  ],
  templateUrl: './asset-page-blur-hash.component.html',
  styleUrl: './asset-page-blur-hash.component.scss',
})
export class AssetPageBlurHashComponent {
  readonly asset = input.required<AssetDto>();

  readonly blurHashValue = computed(() => {
    const asset = this.asset();
    if (!asset) return null;
    return asset.version_data.data?.['exif']?.blurHash || null;
  });
}
